import  React from 'react'

function HeaderInCell ({text}) {
  return (
      <div style={{fontWeight: 300, fontSize: '10px', marginTop: '4px', whiteSpace: 'nowrap', color: '#777'}}>{text}</div>
  )
}

export default HeaderInCell